import { axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError, undefined, 'firstname')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  response = await axiosPut(apiUrls.users + '/' + apiUrls.actionAccount, formData, catchFunc)
  return response
}

export default submitForm
